export default "__VITE_ASSET__C9Ye6a_t__"